import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import { useHistory, useLocation } from 'react-router-dom';
import UnassignedUsersTable from '../components/UnassignedUsersTable';
import * as userActions from '../actions/users';
import * as authService from '../services/auth';
import { Roles } from '../models/roles';
import routes from '../routes';

const UsersUnassignedListView = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const selectedUsers = location?.state?.selectedUsers || [];
  const selectedIds = new Set(selectedUsers.map((u) => u?.id));
  const usersWithoutRoles = useSelector(state => state.entities.users.withoutRoles);
  const usersWithoutRolesList = usersWithoutRoles.allIds
    .map((id) => usersWithoutRoles.byId[id])
    .sort((a, b) => {
      const aSelected = selectedIds.has(a?.id);
      const bSelected = selectedIds.has(b?.id);
      if (aSelected !== bSelected) {
        return aSelected ? -1 : 1;
      }
      return 0;
    });

  const currentlyLoggedInUser = authService.getCurrentlyLoggedInOrImpersonatingUser();
  const isAllowedToDeleteUser = authService.hasAnyRoleInCurrentlySelectedSite(currentlyLoggedInUser, [Roles.Admin]);

  useEffect(() => {
    dispatch(userActions.fetchUsersWithoutRoles());
  }, []);

  const handleSendEmail = (users) =>
    history.push(routes.sendEmail, {
      usersIds: users.map((u) => u.id),
    });

  return (
    <Grid container>
      <Grid item xs={12}>
        <UnassignedUsersTable
          isLoading={usersWithoutRoles.inflight}
          unassignedUsers={usersWithoutRolesList}
          showDeleteUserButton={isAllowedToDeleteUser}
          onUserDelete={user => dispatch(userActions.deleteUserWithoutRoles(user))}
          onSendEmailButtonClick={handleSendEmail}
        />
      </Grid>
    </Grid>
  );
};

export default UsersUnassignedListView;
